import authentication from "@irati/auth";
import { has, isNull } from "lodash";
export var defaultEmployeeName = "employee";
export default (function (plural) {
    if (plural === void 0) { plural = true; }
    var settings = authentication.userTenant().settings;
    var employeeName = has(settings, "employeeName") && !isNull(settings.employeeName)
        ? settings.employeeName
        : defaultEmployeeName;
    return ("" + employeeName + (plural ? "s" : ""));
});
